import { __awaiter, __generator, __spreadArray } from "tslib";
function waitForTimeout(timeout) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeout);
    });
}
export function withMaxWaitLimit(cb, maxWaitMs) {
    if (maxWaitMs === void 0) { maxWaitMs = 500; }
    return Promise.all([cb(), waitForTimeout(maxWaitMs)]);
}
function debounceEventCreator(cb) {
    var _this = this;
    var isPromiseInProgress = false;
    return function (e) { return __awaiter(_this, void 0, void 0, function () {
        function invokePromise() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isPromiseInProgress = true;
                            return [4 /*yield*/, cb()];
                        case 1:
                            _a.sent();
                            isPromiseInProgress = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        var isMainButtonPressed, isAuxiliaryButtonPressed, promiseFn, result;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isMainButtonPressed = e.button === 0;
                    isAuxiliaryButtonPressed = e.button === 1;
                    if (!isMainButtonPressed && !isAuxiliaryButtonPressed) {
                        return [2 /*return*/, Promise.resolve()];
                    }
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    promiseFn = isPromiseInProgress ? function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/];
                    }); }); } : invokePromise;
                    return [4 /*yield*/, promiseFn()];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
}
function triggerOnLinkClick(link, onLinkClick) {
    return __awaiter(this, void 0, void 0, function () {
        var href, target, rel;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    href = link.href, target = link.target, rel = link.rel;
                    return [4 /*yield*/, withMaxWaitLimit(function () { return onLinkClick(href); })];
                case 1:
                    _a.sent();
                    if (target !== '') {
                        window.open(href, target, rel);
                    }
                    else {
                        window.location.replace(href);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function addClickTrackingOnLinks(_a) {
    var _b = _a.domNode, domNode = _b === void 0 ? new Element() : _b, _c = _a.onLinkClick, onLinkClick = _c === void 0 ? function () { return Promise.resolve(null); } : _c;
    var linksArr = Array.from(domNode.querySelectorAll('a'));
    var links = __spreadArray([domNode], linksArr, true).filter(function (el) { return el.matches('a'); })
        .map(function (e) { return e; });
    var linksWithListener = links.map(function (link) { return ({
        link: link,
        listener: debounceEventCreator(function () { return triggerOnLinkClick(link, onLinkClick); }),
    }); });
    linksWithListener.forEach(function (linkWithListener) {
        linkWithListener.link.addEventListener('click', linkWithListener.listener, true);
        linkWithListener.link.addEventListener('auxclick', linkWithListener.listener, true);
    });
    return linksWithListener;
}
